/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ArticleAuthorsDetailView} from "../../article/views/ArticleAuthorsDetailView/ArticleAuthorsDetailView";
import {ArticleAuthorsListView} from "../../article/views/ArticleAuthorsList";
import {ArticleDetailView} from "../../article/views/ArticleDetailView";
import {ArticleListView} from "../../article/views/ArticleListView";
import {ArticleCategoryListView} from "../../article/views/ArticlesCategoryListView";
const route = [
    {webpackEntry: "articles", path: rpAppPath.article.detail, component: ArticleDetailView},
    {webpackEntry: "articles", path: rpAppPath.article.list, component: ArticleListView},
    {webpackEntry: "articles", path: rpAppPath.article.category, component: ArticleCategoryListView},
    {webpackEntry: "articles", path: rpAppPath.article.author.detail, component: ArticleAuthorsDetailView},
    {webpackEntry: "articles", path: rpAppPath.article.author.list, component: ArticleAuthorsListView}
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ArticleAuthorsDetailView} from "../../article/views/ArticleAuthorsDetailView/ArticleAuthorsDetailView";
import {ArticleAuthorsListView} from "../../article/views/ArticleAuthorsList";
import {ArticleDetailView} from "../../article/views/ArticleDetailView";
import {ArticleListView} from "../../article/views/ArticleListView";
import {ArticleCategoryListView} from "../../article/views/ArticlesCategoryListView";
const route = [
    {webpackEntry: "articles", path: rpAppPath.article.detail, component: ArticleDetailView},
    {webpackEntry: "articles", path: rpAppPath.article.list, component: ArticleListView},
    {webpackEntry: "articles", path: rpAppPath.article.category, component: ArticleCategoryListView},
    {webpackEntry: "articles", path: rpAppPath.article.author.detail, component: ArticleAuthorsDetailView},
    {webpackEntry: "articles", path: rpAppPath.article.author.list, component: ArticleAuthorsListView}
];

(function () {
    rpClient(route);
})();
